export default __webpack_public_path__ + "static/media/Despoiler's Belt of the Dusk Rebellion.72da5ca7.jpg";